const AskVideo = 1;
const Reviewed = 3;
const WellDone = 1;

export type SubmissionTone = "warn" | "accent" | "ok" | "neutral";

// Where a place that asks for a video or a photo stands, as a CzChip; act is true when the patient has to send.
export interface SubmissionState {
  text: string;
  tone: SubmissionTone;
  act: boolean;
}

export function submissionState(place: any, t: (key: string) => string): SubmissionState | null {
  if (!place) return null;
  const video = place.kind === AskVideo;
  const s = place.submission;
  if (!s) return place.canSend ? { text: t(video ? "Your video is missing" : "Your photo is missing"), tone: "accent", act: true } : null;
  if (s.status === Reviewed && s.result === WellDone) return { text: t(video ? "Video: well done" : "Photo: well done"), tone: "ok", act: false };
  if (s.status === Reviewed) return { text: t(video ? "Video: to correct" : "Photo: to correct"), tone: "warn", act: place.canSend };
  if (s.rejected) return { text: t("Could not be used: send another one"), tone: "warn", act: true };
  if (s.mediaDeleted) return { text: t("Not reviewed: send it again"), tone: "accent", act: true };
  return { text: t(video ? "Video sent" : "Photo sent"), tone: "neutral", act: false };
}
